import {
	Line,
	mixins
} from 'vue-chartjs'

export default {
	extends: Line,

	data: () => ({
		loaded: false,
		options: {
			responsive: true,
			maintainAspectRatio: false
		}
	}),

	props: {
		chartdata: {
			type: Object,
			default: () => {}
		}
	},

	async mounted() {
		this.renderChart(this.chartdata, this.options)
	},
}